import React from "react";
import { LazyLoadImages } from "@quintype/components";
import { HomePage as HomePageBase } from "../components/pages/home";
import { DfpAd } from "../../isomorphic/components/atoms/dfp-ad";

function wrapLazyLoadImages(Template) {
  const ImageLazyLoadedComponent = props => {
    return (
      <React.Fragment>
        <div className="automated-ad-unit">
          <DfpAd adtype="Automated" placement="all" />
        </div>
        <div className="header-ad-unit">
          <DfpAd adtype="Large_Leaderboard" placement="all" />
        </div>
        <LazyLoadImages margin={"150px"}>
          <Template {...props} />
        </LazyLoadImages>
      </React.Fragment>
    );
  };
  ImageLazyLoadedComponent.displayName = `WrapLazyLoadImages(${Template.name})`;
  return ImageLazyLoadedComponent;
}

export const HomePage = wrapLazyLoadImages(HomePageBase);
